import { render, staticRenderFns } from "./Esg.vue?vue&type=template&id=81aa1890&scoped=true"
import script from "./Esg.vue?vue&type=script&lang=js"
export * from "./Esg.vue?vue&type=script&lang=js"
import style0 from "./Esg.vue?vue&type=style&index=0&id=81aa1890&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81aa1890",
  null
  
)

export default component.exports